import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';
import FieldWarning         from '../Fragments/FieldWarning';
import InputElement         from 'react-input-mask';

let Quote = require('../Managers/Quote');
let Validation = require('../Managers/Validation.js');

class MoneyInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            isValid: false,
            activeValue: props.defaultValue ? props.defaultValue : null,
        };
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            if (this.props.isValid) {
                this.props.isValid(true);
            }
        }
    }

    /**
     * Pass in the validation rule to apply against the user-provided value.
     *
     * @param event
     */
    setActiveValue(value) {
        let validation = Validation.validate(this.props.dataValidation, value, 'not_null')[0];

        if (this.props.isValid) {
            this.setState(Object.assign({}, validation, { activeValue: value }), () => {
                this.props.isValid(validation.isValid, value);
            });
        }

        // For money fields, always save to 2dp
        if (String(value).indexOf('.') != -1) {
            Quote.set(this.props.storageKey, parseFloat(value), this.props.source);
        } else {
            Quote.set(this.props.storageKey, parseFloat(value + '.00'), this.props.source);
        }

        if (this.props.callbackFunction) {
            this.props.callbackFunction(value);
        }
    }

    handleValidation(e) {
        this.setActiveValue(e);
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    render() {
        return(
            <div className="question-input">
                <div className="input-group money-group">
                    <span className="input-group-addon left">&pound;</span>
                    {this.props.inputMask ?
                        <InputElement
                            name={this.props.fieldName}
                            id={this.props.fieldName}
                            className="right"
                            maskChar={null}
                            onBlur={(event) => { this.setActiveValue(event.target.value); }}
                            placeholder={this.props.placeholder}
                            onKeyDown={(e) => {
                                // @TODO look into react keyDown event, maybe
                                // theres some kind of "isSpecialChar" or
                                // "isInsertsSymbol" ? i looked but couldnt find anything
                                switch (e.key) {
                                    case 'Backspace':
                                    case 'Delete':
                                    case 'ArrowRight':
                                    case 'ArrowLeft':
                                    case 'Tab':
                                        return true;
                                }

                                // dont allow anything other than ints, an int
                                // and a decimal, or an int a decimal and then
                                // 1 or 2 ints. if its still malformed (i.e they
                                // just finish on 34.) the final validation regex
                                // will catch it
                                const newValue = e.target.value + String(e.key);
                                const regexp = /^[0-9]+[.]?[0-9]{0,2}$/;

                                if (!regexp.test(newValue)) {
                                    e.preventDefault();
                                }
                            }}
                            formatChars={{
                                "9": "[0-9]",
                                "a": "[A-Za-z]",
                                "*": "[A-Za-z0-9]",
                                "M": "([0-9]|.)",
                            }}
                            defaultValue={this.props.defaultValue}
                        />
                    :
                        <input
                            type="number"
                            name={this.props.fieldName}
                            id={this.props.fieldName}
                            className="right"
                            onBlur={(event) => { this.setActiveValue(event.target.value); }}
                            placeholder={this.props.placeholder}
                            defaultValue={this.props.defaultValue}
                        />
                    }
                </div>

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
                {this.state.hasWarning === true ?
                    <FieldWarning warnings={this.state.warnings} />
                :null}
            </div>
        );
    }
}

MoneyInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    inputMask:          PropTypes.string,
    placeholder:        PropTypes.string,
    callbackFunction:   PropTypes.func,
    dataValidation:     PropTypes.string,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    source:             PropTypes.string,
    isValid:            PropTypes.func,
};

export default MoneyInput;


// WEBPACK FOOTER //
// ./src/components/Fields/MoneyInput.js